var _style, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUniteam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FF4F19;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25,47.2c-12.2,0-22.2-10-22.2-22.2S12.8,2.8,25,2.8s22.2,10,22.2,22.2c0,2.1-0.3,4.2-0.9,6.3l-0.7-0.2 c0.6-2,0.9-4,0.9-6.1c0-11.9-9.6-21.5-21.5-21.5C13.1,3.5,3.5,13.1,3.5,25S13.1,46.5,25,46.5V47.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25,50C11.2,50,0,38.8,0,25c0-2.4,0.3-4.8,1-7.1l0.7,0.2c-0.7,2.2-1,4.5-1,6.9c0,13.4,10.9,24.3,24.3,24.3 S49.3,38.4,49.3,25S38.4,0.7,25,0.7V0c13.8,0,25,11.2,25,25S38.8,50,25,50z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21.7,27.9c0,0.2,0.2,0.4,0.4,0.4h1.6c0.2,0,0.4-0.2,0.4-0.4v-2.5c0-0.2-0.2-0.4-0.4-0.4h-1.6 c-0.2,0-0.4,0.2-0.4,0.4V27.9z M22.5,25.8h0.8v1.6h-0.8V25.8z M22.5,25.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M22.1,23.4h1.6c0.2,0,0.4-0.2,0.4-0.4v-2.5c0-0.2-0.2-0.4-0.4-0.4h-1.6c-0.2,0-0.4,0.2-0.4,0.4V23 C21.7,23.2,21.9,23.4,22.1,23.4L22.1,23.4z M22.5,20.9h0.8v1.6h-0.8V20.9z M22.5,20.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.1,20.4l5.9-3.6l5.9,3.6c0.1,0,0.1,0.1,0.2,0.1c0.1,0,0.3-0.1,0.4-0.2c0.1-0.2,0.1-0.4-0.1-0.6l-5.9-3.6 v-2.6h2v0.8h-1.2c-0.2,0-0.4,0.2-0.4,0.4c0,0.2,0.2,0.4,0.4,0.4h1.6c0.2,0,0.4-0.2,0.4-0.4v-1.6c0-0.2-0.2-0.4-0.4-0.4H25 c-0.2,0-0.4,0.2-0.4,0.4v3l-5.9,3.6c-0.2,0.1-0.3,0.4-0.1,0.6C18.6,20.5,18.9,20.6,19.1,20.4L19.1,20.4z M19.1,20.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17.2,28.3c0.2,0,0.4-0.2,0.4-0.4v-2.5c0-0.2-0.2-0.4-0.4-0.4h-1.6c-0.2,0-0.4,0.2-0.4,0.4v0.8 c0,0.2,0.2,0.4,0.4,0.4c0.2,0,0.4-0.2,0.4-0.4v-0.4h0.8v2C16.8,28.1,17,28.3,17.2,28.3L17.2,28.3z M17.2,28.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20.1,33.6V21.7c0-0.2-0.2-0.4-0.4-0.4c-0.2,0-0.4,0.2-0.4,0.4v11.9c0,0.2,0.2,0.4,0.4,0.4 C19.9,34,20.1,33.8,20.1,33.6L20.1,33.6z M20.1,33.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18,35.6H32c0.2,0,0.4-0.2,0.4-0.4c0-0.2-0.2-0.4-0.4-0.4h-3.7v-4.1h0.4c0.2,0,0.4-0.2,0.4-0.4 c0-0.2-0.2-0.4-0.4-0.4h-7.4c-0.2,0-0.4,0.2-0.4,0.4c0,0.2,0.2,0.4,0.4,0.4h0.4v4.1H18c-0.2,0-0.4,0.2-0.4,0.4 C17.6,35.4,17.8,35.6,18,35.6L18,35.6z M25.4,33.2c0.2,0,0.4-0.2,0.4-0.4c0-0.2-0.2-0.4-0.4-0.4v-1.6h2v4.1h-2V33.2z M22.5,30.7h2 v1.6c-0.2,0-0.4,0.2-0.4,0.4c0,0.2,0.2,0.4,0.4,0.4v1.6h-2V30.7z M22.5,30.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M34.4,30.3h-1.6c-0.2,0-0.4,0.2-0.4,0.4v2.5c0,0.2,0.2,0.4,0.4,0.4h1.6c0.2,0,0.4-0.2,0.4-0.4v-2.5 C34.8,30.5,34.6,30.3,34.4,30.3L34.4,30.3z M34,32.8h-0.8v-1.6H34V32.8z M34,32.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M34.4,25.4h-1.6c-0.2,0-0.4,0.2-0.4,0.4v2.5c0,0.2,0.2,0.4,0.4,0.4h1.6c0.2,0,0.4-0.2,0.4-0.4v-2.5 C34.8,25.6,34.6,25.4,34.4,25.4L34.4,25.4z M34,27.9h-0.8v-1.6H34V27.9z M34,27.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M33.6,36.5H16.4c-0.2,0-0.4,0.2-0.4,0.4c0,0.2,0.2,0.4,0.4,0.4h17.2c0.2,0,0.4-0.2,0.4-0.4 C34,36.6,33.8,36.5,33.6,36.5L33.6,36.5z M33.6,36.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M36.9,21.7c-0.2,0-0.4,0.2-0.4,0.4v0.4H32c-0.2,0-0.4,0.2-0.4,0.4c0,0.2,0.2,0.4,0.4,0.4h4.5v13.5 c0,0.2,0.2,0.4,0.4,0.4c0.2,0,0.4-0.2,0.4-0.4V22.1C37.3,21.9,37.1,21.7,36.9,21.7L36.9,21.7z M36.9,21.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25.8,27.9c0,0.2,0.2,0.4,0.4,0.4h1.6c0.2,0,0.4-0.2,0.4-0.4v-2.5c0-0.2-0.2-0.4-0.4-0.4h-1.6 c-0.2,0-0.4,0.2-0.4,0.4V27.9z M26.6,25.8h0.8v1.6h-0.8V25.8z M26.6,25.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16.8,32.8c0-0.1,0-5.3-2-5.3c-2,0-2,5.3-2,5.3c0,1,0.7,1.8,1.6,2v2.1c0,0.2,0.2,0.4,0.4,0.4 c0.2,0,0.4-0.2,0.4-0.4v-2.1C16.1,34.6,16.8,33.8,16.8,32.8L16.8,32.8z M14.8,34c-0.7,0-1.2-0.6-1.2-1.2c0-2,0.5-4.5,1.2-4.5 c0.7,0,1.2,2.5,1.2,4.5C16,33.4,15.5,34,14.8,34L14.8,34z M14.8,34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M30.7,33.6V21.3c0-0.2-0.2-0.4-0.4-0.4c-0.2,0-0.4,0.2-0.4,0.4v12.3c0,0.2,0.2,0.4,0.4,0.4 C30.5,34,30.7,33.8,30.7,33.6L30.7,33.6z M30.7,33.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M26.2,23.4h1.6c0.2,0,0.4-0.2,0.4-0.4v-2.5c0-0.2-0.2-0.4-0.4-0.4h-1.6c-0.2,0-0.4,0.2-0.4,0.4V23 C25.8,23.2,26,23.4,26.2,23.4L26.2,23.4z M26.6,20.9h0.8v1.6h-0.8V20.9z M26.6,20.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.1,27c0.2,0,0.4-0.2,0.4-0.4v-3.3H18c0.2,0,0.4-0.2,0.4-0.4c0-0.2-0.2-0.4-0.4-0.4h-4.5v-0.4 c0-0.2-0.2-0.4-0.4-0.4c-0.2,0-0.4,0.2-0.4,0.4v4.5C12.7,26.9,12.9,27,13.1,27L13.1,27z M13.1,27"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUniteam);
export default __webpack_public_path__ + "static/media/uniteam.238602632884440ad164d851a8f8e5e6.svg";
export { ForwardRef as ReactComponent };